var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffff",
    fillRule: "nonzero",
    d: "M.886.727a.799.799 0 0 0-.795.796v11.136c0 .437.359.796.795.796h1.932a2.728 2.728 0 0 0 5.455 0h2.84a.799.799 0 0 0 .796-.796V1.523a.799.799 0 0 0-.795-.796H.886zm12.529 1.818a.598.598 0 0 0-.597.597v9.716a.59.59 0 0 0 .37.54.612.612 0 0 0 .227.057h1.221a2.728 2.728 0 0 0 5.455 0h1.221a.55.55 0 0 0 .228-.057.585.585 0 0 0 .312-.313.55.55 0 0 0 .057-.227V8.17a.57.57 0 0 0-.114-.312l-3.352-5.057a.57.57 0 0 0-.483-.256h-4.545zm2.13 1.819h2.302L20.26 8h-4.716V4.364zm-10 7.727a1.364 1.364 0 1 1 0 2.728 1.364 1.364 0 0 1 0-2.728zm11.819 0a1.364 1.364 0 1 1-.001 2.728 1.364 1.364 0 0 1 0-2.728z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.90b25f0a1afe8f31e7e90594d4806d8e.svg";
export { ForwardRef as ReactComponent };